import { render, staticRenderFns } from "./VeHistogram.vue?vue&type=template&id=509a46fa&scoped=true&"
import script from "./VeHistogram.vue?vue&type=script&lang=js&"
export * from "./VeHistogram.vue?vue&type=script&lang=js&"
import style0 from "./VeHistogram.vue?vue&type=style&index=0&id=509a46fa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "509a46fa",
  null
  
)

export default component.exports